export const ENUM_QUERY_PARAMS = {
    USUARIO_ACTION_PASS_ID: 'usuarioActionPassId',
    LOGOUT: 'logout',
    ID_CITA_INFO: 'idCita'
};
